<template lang="html">
  <div class="province-F">
    <div class="ttBar">
      <span>连续型电子出版物出版单位查询</span>
    </div>
    <div class="tabArea">
      <div class="seekArea">
        <el-input
          size="small"
          :style="{ width: '360px' }"
          v-model="params.keyword"
          placeholder="省局名称、出版物名称"></el-input>
        <el-select v-model="selYear" @change="valChange" class="lnjlClass" size="small" placeholder="历年记录">
          <el-option v-for="item in selYearRecord" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button size="small" @click="goSeek">查询</el-button>
      </div>
      <el-table :data="tabDats" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + 12 * (params.no - 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="sjExamine" label="省局名称" align="center"> </el-table-column>
        <el-table-column prop="organizationName" label="出版单位" align="center"> </el-table-column>
        <el-table-column prop="name" label="出版物名称" align="center"> </el-table-column>
        <el-table-column width="100" label="省局意见" prop="statussj" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row | transStr("statussj") }}</span>
          </template>
        </el-table-column>
        <el-table-column width="150" label="国家新闻出版署意见" prop="statuszj" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row | transZjStr("statuszj") }}</span>
          </template>
        </el-table-column>
        <el-table-column width="200" prop="progress" label="状态" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.progress == "开始" ? "" : scope.row.progress == "登记" ? "已发布" : scope.row.progress
            }}</span>
          </template>
        </el-table-column>
        <el-table-column width="150" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="goFirm(scope.row, 2)" type="primary" size="mini">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pageCage" v-if="params.pgAll > 1">
        <el-pagination
          @current-change="pageSent"
          :current-page="params.no"
          layout="prev, pager, next"
          :page-count="params.pgAll">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { successiveSeek } from "@/api/provinceRole/provinceRole";
import { getSelYearRecord } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      tabDats: [],
      params: {
        keyword: "",
        year1: "",
        sjExamineId: "",
        no: 1,
        size: 12,
        pgAll: 0,
      },
      selYear: "",
      selYearRecord: [{}],
    };
  },
  filters: {
    transZjStr: function (dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        let map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布",
        };
        return map[dat.statuszj];
      }
    },
    transStr: function (dat, code) {
      // console.log("省局：", code, " ", dat);
      if (code == "statussj") {
        let map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          9: "整体上报", // 开放
          11: "已登记",

          12: "省局暂缓", // 开放
          13: "注销或拟注销",
          // 14: "建议撤销",
        };
        return map[dat.statussj];
      }
    },
  },

  methods: {
    tabList: function () {
      successiveSeek(this.params).then((response) => {
        console.log("response==", response);
        this.tabDats = response.generalLxPublisher;
        this.params.pgAll = response.totalPages;
      });
    },
    goFirm: function (rows) {
      this.$router.push({
        path: "successive_skim",
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.id,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: 3,
          year1: this.selYear,
        },
      });
    },
    pageSent: function (inx) {
      this.params.no = inx;
      this.tabList();
    },
    goSeek: function () {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabList();
    },
    valChange: function () {
      this.params.year1 = this.selYear;
      sessionStorage.setItem("selYearLxdz", this.selYear);
      this.tabList();
    },
  },

  created: function () {
    var selYearLxdz = sessionStorage.getItem("selYearLxdz") || "";
    getSelYearRecord({
      publishId: "",
      type: 3,
    }).then((response) => {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            this.params.year1 = po.firstYear;
            this.selYear = po.firstYear;
            if (selYearLxdz != "") {
              this.params.year1 = selYearLxdz;
              this.selYear = selYearLxdz;
            }
          }
        }
      }
      this.selYearRecord = arr;
      this.tabList();
    });
  },
};
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;

  .ttBar {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0 20px;
    color: #666666;
    font-weight: bold;
  }

  .tabArea {
    margin-top: 12px;

    .seekArea {
      margin-bottom: 12px;

      .el-input {
        input {
          border-radius: 0px;
        }
      }
    }

    .pageCage {
      text-align: center;
      margin: 30px auto;
    }
  }
}

.lnjlClass {
  float: right;
  width: 180px;
}

.lnjlClass > div > input {
  width: 180px;
}
</style>



// WEBPACK FOOTER //
// successivePressSeek.vue?61a18d40